export const TRUSTPILOT_RATING_VALUE = 4.8;
export const TRUSTPILOT_RATING_COUNT = '545';
export const TRUSTPILOT_LAST_UPDATED_DATE = '18.09.2026';
